import createUmbracoMediaItemProps from '@/components/atoms/media/umbracoMediaElementPropsFactory'

import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
import { MediaImageData } from '@/components/atoms/media/MediaImage'
import { LogoCarousel } from './logoCarousel'

export default function logoCarouselFactory(data: any, key: string | number) {
  const content = data.content.properties

  const mediaItem = {
    contentType: 'imageComponent',
    properties: {
      image: content?.image,
    },
  }
  const logoItems =
    content?.items?.items?.map((item: any, index: number) => {
      const mediaItem = item.content
      const mediaItemProps = createUmbracoMediaItemProps({
        mediaItemContent: mediaItem,
        umbracoBaseUrl: GetUmbracoBaseUrl(),
      })

      return {
        key: index,
        id: index,
        image: mediaItemProps as MediaImageData,
      }
    }) || []

  return (
    <LogoCarousel key={key} title={content.title.markup} items={logoItems} />
  )
}
